export default __webpack_public_path__ + "static/media/heater2.0d871e82.jpeg";